// export const baseURL = "https://www.peakbooks.biz:2020/";
// export const baseURL = "http://159.122.225.148:2020/";
export const baseURL_Radio_Compaign = "https://api.funuapesa.co.tz/";
export const baseURL = "https://api.funuapesa.co.tz/";

// export const baseURL = "http://0.0.0.0:8096/";
// export const baseURL_Radio_Compaign = "https://luckybox.ng:8096/";
// Warning std versions prefixed with 'v' will be deprecated on October 1st 2020. Please change your import to  (at https://deno.land/std@v0.63.0/fmt/colors.ts)